import script from "./imageBox.vue?vue&type=script&setup=true&lang=js"
export * from "./imageBox.vue?vue&type=script&setup=true&lang=js"

import "./imageBox.vue?vue&type=style&index=0&id=0526defe&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0526defe"]])

export default __exports__